
import { useMutation, useQuery } from "react-query"
import { useToast } from "../../../hook/usetoast";
import DataService from '../../../config/DataServices'
import { queryClient } from "../../../config";

const { postRequest, getRequest } = DataService()



export const useAirDropActivate = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/auth/activateAccount", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            queryClient.refetchQueries("get-amount")
            return toast.success(success?.message)
        }
    })
}



export const useGetAirdropAmount = () => {

    return useQuery({
        queryKey: ["get-amount"],
        queryFn: () => {
            return getRequest(`user/auth/airDrop-amount`)
        }
    })
}




export const useClaimAirdrop = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/auth/claimAirdropReward", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            queryClient.refetchQueries("get-profile")

            return toast.success(success?.message)
        }
    })
}